import { LegalShell } from './legal-shell.tsx'
import { TERMS_AND_CONDITIONS } from './terms-content.ts'

export function TermsPage() {
  return <LegalShell translations={TERMS_AND_CONDITIONS} current="terms" />
}
